import { UserProfile } from 'people';
import { BackButton } from '../../Components';
import { DrawerNav } from '../const';
import { useStyles } from './DrawerMyProfile.style';

export const DrawerMyProfile: React.FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <BackButton buttonText="My Profile" to={DrawerNav.DEFAULT_NAVIGATION} />

            <UserProfile />
        </div>
    );
};
